module.exports = __webpack_public_path__ + "img/public/siteImages/docsVerify.svg?41b9bdd7";